module.exports = __webpack_public_path__ + "img/empty-state-challenge.e21ea64a.png";